import { companyConstants } from "../../_constants";

const initialState = {};

export const create_company_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case companyConstants.CREATE_COMPANY_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case companyConstants.CREATE_COMPANY_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        companyData: action.payload,
      };
    case companyConstants.CREATE_COMPANY_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        createCompanyError: action.payload,
      };
    default:
      return state;
  }
};

export const get_company_details_hiring_manager_reduer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case companyConstants.GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case companyConstants.GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_SUCCESS:
    case companyConstants.UPDATE_COMPANY_DETAILS_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        companyData: action.payload,
      };
    case companyConstants.GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};
